/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TValidatePhoneRequest, TValidatePhoneModel, IMappers, TValidatePhoneResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IValidatePhoneResponse } from '../../entities/public_v1_validate_phone/ValidatePhoneResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createValidatePhoneModel(parameters: TValidatePhoneRequest): TValidatePhoneModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'demand',
    pathApi: '/v1/validate-phone/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IValidatePhoneOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TValidatePhoneRequest;
}

export async function fetchValidatePhone<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IValidatePhoneOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TValidatePhoneResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createValidatePhoneModel(parameters),
    config,
  )) as FetchResponse<TValidatePhoneResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IValidatePhoneResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TValidatePhoneResponse>;
}
